<template lang="pug">
  .enrollment-element-configuration
    v-scroll-y-transition
      v-item-group(
        v-if="!loading.init"
        v-model="statements.selected"
        multiple
      )
        v-expand-transition
          v-row
            v-col(
              v-for="statement in statements.items"
              :key="statement.id"
            )
              v-expand-transition(mode="out-in")
                v-item(
                  v-slot="{ active, toggle }"
                  :value="statement.id"
                )
                  v-card(
                    outlined
                    :color="active ? 'secondary' : ''"
                    :dark="active"
                    @click="() => { toggle(); formInteracted = true }"
                  ).mr-4.align-center.sdo-radius.fill-height
                    v-card-text
                      v-icon(large).mb-2 mdi-file-document-plus
                      div {{ statement.name }}
                      v-checkbox(
                        v-model="enrollment.is_enrollment_scan_required"
                        v-if="statement.type === 1 && active"
                        label="Нужен скан заявления" hide-details @click.stop
                      )
    v-row
      v-col(cols="12", md="6")
        v-list(
          v-if="hasAttributes"
          color="transparent"
        )
          v-subheader.mt-8 Дополнительные поля для зачисленияю
          v-list-item(
            v-for="field in allAttrsDict"
            :key="field.id"
          )
            v-list-item-avatar
              tooltip-wrap(
                :text="INPUT_TEXT_TYPES[field.type]"
              )
                v-icon {{ INPUT_TYPES_ICONS[field.type] }}
            v-list-item-content
              v-list-item-title {{ field.name }}
              v-list-item-subtitle {{ field.description }}
              v-list-item-subtitle(
                v-for="statement in field.statements"
                :key="statement.id"
              ) - {{ statement.name }}
            v-list-item-action(v-if="!field.statements")
              v-btn(icon color="error" @click="deleteAttr(field.id)"): v-icon mdi-delete
    .pa-0.mt-10
      v-btn(
        large
        rounded
        depressed
        color="success"
        outlined
        @click="selectedField = fieldInstance()"
      ).px-5.mr-2
        v-icon mdi-plus
        .ml-4 Поле к зачислению

      v-btn(
        large
        rounded
        depressed
        :disabled="!formInteracted"
        :loading="loading.save"
        color="success"
        @click="save"
      ).px-5 Сохранить

    inputs-dialog(
      :editable="isEditableSelectedField"
      :value="selectedField"
      @close="selectedField = null"
      @update="onAddField"
    )
</template>
<script>
import InputsDialog from '../../InputsDialog.vue';
import { INPUT_TEXT_TYPES, INPUT_TYPES_ICONS } from '../../../constants';

const fieldInstance = () => ({
  name: '',
  type: null,
  editable: false,
});

export default {
  components: {
    InputsDialog,
  },
  props: {
    course: { type: Object, required: true },
    enrollment: { type: Object, default: () => ({ attributes: [] }) },
  },
  data() {
    return {
      INPUT_TEXT_TYPES,
      INPUT_TYPES_ICONS,

      fieldInstance,
      selectedField: null,

      statements: {
        items: [],
        selected: [],
      },
      attributes: [],

      formInteracted: false,

      loading: {
        init: false,
        save: false,
      },
    };
  },
  watch: {
    'enrollment.is_enrollment_scan_required': {
      handler() {
        this.formInteracted = true;
      },
    },
    'statements.selected': {
      handler(v) {
        console.log(v);
        if (!v.find((i) => i === 1)) this.enrollment.is_enrollment_scan_required = false;
      },
    },
  },
  computed: {
    isEditableSelectedField() {
      return !!this.selectedField?.editable;
    },
    hasAttributes() {
      return Object.keys(this.allAttrsDict).length;
    },
    /**
     * Мержит атрибуты заявляения и пользователя
     */
    allAttrsDict() {
      const statementAttrs = !Object.entries(this.statements.items).length
        ? [] : this.statements.selected.map((i) => this.statements.items[i]);

      const mergedAttrs = [
        ...statementAttrs.reduce((acc, item) => {
          const atrubutes = item.attributes.map((it) => ({ ...it, statements: [item] }));
          return [...acc, ...atrubutes];
        }, []),
        ...statementAttrs
          ? this.attributes
            .filter((item) => (item.alias ? item.statements && !item.statements.length : true))
          : [this.attributes],
      ];
      return mergedAttrs;
    },
    savedStatementsIds() {
      return this.enrollment.statements.map((i) => i.id);
    },
  },
  created() {
    this.fetchStatements();
    this.attributes = [...this.enrollment.attributes];
    this.statements.selected = [...this.savedStatementsIds];
  },
  methods: {
    deleteAttr(id) {
      this.formInteracted = true;
      const idx = this.attributes.findIndex((i) => i.id === id);
      this.attributes.splice(idx, 1);
    },
    async fetchStatements() {
      this.loading.init = true;
      const { items } = await this.$api.enrollments.statements({
        params: {
          expand: 'attributes',
          'search[course_type]': this.course.type,
        },
        rOptions: { many: true },
      });
      this.sortStatmets(items);
      this.loading.init = false;
    },

    sortStatmets(items) {
      const requestEnrollStatment = 1;
      this.statements.items = items.reduce((acc, item) => {
        const statment = item;
        if (statment.id === requestEnrollStatment) {
          statment.attributes.sort((element) => (element.id === 71 ? -1 : 1));
        }
        const result = { [item.id]: statment };
        return { ...acc, ...result };
      }, {});
    },

    onAddField() {
      this.formInteracted = true;
      this.attributes.push(this.selectedField);
    },
    async save() {
      this.loading.save = true;
      const payload = {
        ...this.enrollment,
        attributes: this.attributes.map((i) => ({ ...i, is_required: true })),
        statements: this.statements.selected,
      };
      await this.$api.enrollments.updateEnrollment(payload);
      this.$toasted.success('Конфиграция успешно сохранена');
      this.formInteracted = false;
      this.loading.save = false;
    },
  },
};
</script>
